import { word } from "@modules/core/utils/i18n"
import { HUText } from "@modules/ui/components/huText"

type Props = {
  title?: string
  error?: Error
} & React.HTMLAttributes<HTMLDivElement>
export const ErrorCard: React.FC<Props> = ({ title, error }) => {
  return (
    <div className="card flex flex-column gap-3">
      <HUText fontStyle="HM" className="align-items-center justify-content-center">
        {title ?? word("global.error.default")}
      </HUText>
      {error && <HUText>{error.message}</HUText>}
    </div>
  )
}
